import React, { useMemo } from 'react';
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from 'react-table';

import { FaSort, FaSortUp, FaSortDown } from 'react-icons/fa';
import { Col, Container, Row, Spinner, Table } from 'react-bootstrap';
import { TablePagination } from '../../../components';
import './styles.scoped.css';

function getSortedIcon(isSorted, isSortedDesc) {
  let iconProp = <FaSort />;
  if (isSorted) {
    iconProp = isSortedDesc ? <FaSortDown /> : <FaSortUp />;
  }
  return iconProp;
}

const columnClassName = 'align-middle text-nowrap';
export const grossMarginAMCColumns = [
  {
    Header: 'Branch',
    accessor: 'Branch',
    className: columnClassName,
  },
  {
    Header: 'LOB',
    accessor: 'LOB',
    className: columnClassName,
  },
  {
    Header: 'AMC',
    accessor: 'AMC',
    className: columnClassName,
  },
  {
    Header: 'Assign Period End Date',
    accessor: 'Assignment_PeriodEndingDate',
    className: columnClassName,
  },
  {
    Header: 'T Invoice Company Name',
    accessor: 'T_INVOICE_COMPANY_NAME',
    className: columnClassName,
  },
  {
    Header: 'Client BillTo Number',
    accessor: 'T_BILL_TO',
    className: columnClassName,
  },
  {
    Header: 'Assgn Intv Cnslt',
    accessor: 'ASS_PC',
    className: columnClassName,
  },
  {
    Header: 'Job Cnslt',
    accessor: 'JOB_PC',
    className: columnClassName,
  },
  {
    Header: 'SPC Cnslt',
    accessor: 'CUST_SALESPC',
    className: columnClassName,
  },
  {
    Header: 'Applicant Name',
    accessor: 'Applicant_Name',
    className: columnClassName,
  },
  {
    Header: 'Applicant Empl Number',
    accessor: 'Applicant_Empl_Number',
    className: columnClassName,
  },
  {
    Header: 'Transaction Type',
    accessor: 'Transaction_Type',
    className: columnClassName,
  },
  {
    Header: 'Pay Code Type',
    accessor: 'Pay_Code_Type',
    className: columnClassName,
  },
  {
    Header: 'Bill Hours',
    accessor: 'Bill_Hours',
    className: columnClassName,
  },
  {
    Header: 'Bill Amount',
    accessor: 'Bill_Amount',
    className: columnClassName,
  },
  {
    Header: 'Pay Hours',
    accessor: 'Pay_Hours',
    className: columnClassName,
  },
  {
    Header: 'Pay Amount',
    accessor: 'Pay_Amount',
    className: columnClassName,
  },
  {
    Header: 'Federal Burden',
    accessor: 'Federal_Burden',
    className: columnClassName,
  },
  {
    Header: 'State SUI Burden',
    accessor: 'STATE_SUI_Burden',
    className: columnClassName,
  },
  {
    Header: 'WC Amount',
    accessor: 'WC_Amount',
    className: columnClassName,
  },
  {
    Header: 'Additional Burden',
    accessor: 'Additional_Burden',
    className: columnClassName,
  },
  {
    Header: 'Payroll Cost',
    accessor: 'Payroll_Cost',
    className: columnClassName,
  },
  {
    Header: 'Gross Margin',
    accessor: 'Gross_Margin',
    className: columnClassName,
  },
  {
    Header: 'Margin',
    accessor: 'Margin',
    className: columnClassName,
  },
  {
    Header: 'Markup',
    accessor: 'Markup',
    className: columnClassName,
  },
  {
    Header: 'WC Code',
    accessor: 'Job_WC_Code',
    className: columnClassName,
  },
  {
    Header: 'WC State',
    accessor: 'Job_WC_State',
    className: columnClassName,
  },
];

const GrossMarginAMCTable = ({ data, loading }) => {
  const memoData = useMemo(() => data, [data]);

  const tableInstance = useTable(
    {
      columns: grossMarginAMCColumns,
      data: memoData,
      initialState: {
        pageSize: 200,
        sortBy: [
          {
            id: 'CreatedAt',
            desc: true,
          },
        ],
      },
    },
    useGlobalFilter,
    useSortBy,
    usePagination,
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
  } = tableInstance;

  const tableHeaders = headerGroups.map(headerGroup => {
    const headers = headerGroup.headers.map(column => (
      <th {...column.getHeaderProps(column.getSortByToggleProps())}>
        {column.render('Header')}
        <span>
          {column.canSort
            ? getSortedIcon(column.isSorted, column.isSortedDesc)
            : null}
        </span>
      </th>
    ));
    return <tr {...headerGroup.getHeaderGroupProps()}>{headers}</tr>;
  });

  const tableRows = page.map(row => {
    prepareRow(row);
    const cells = row.cells.map(cell => (
      <td
        {...cell.getCellProps({
          className: cell.column.className,
          style: cell.column.style,
        })}
      >
        {cell.render('Cell')}
      </td>
    ));

    return <tr {...row.getRowProps()}>{cells}</tr>;
  });

  return (
    <Container fluid>
      <Row className="align-items-center">
        <Col className="d-flex justify-content-center justify-content-md-end">
          <TablePagination tableInstance={tableInstance} />
        </Col>
      </Row>
      <Row>
        <Col className="border border-light rounded shadow-sm">
          <Table hover responsive borderless {...getTableProps()}>
            <thead className="text-nowrap">{tableHeaders}</thead>
            <tbody {...getTableBodyProps()}>{tableRows}</tbody>
          </Table>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {loading && <Spinner animation="border" />}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default GrossMarginAMCTable;
